import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice'
import marketSlice from './slices/marketSlice'
import tradingSlice from './slices/tradingSlice'
import portfolioSlice from './slices/portfolioSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    market: marketSlice,
    trading: tradingSlice,
    portfolio: portfolioSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch